'use client'

import { useEffect, useState } from 'react'

// Careers admin toolbar: status pipeline counts with live query
// The "new" chip is the attention queue — styled with kingdom gold when non-zero

const STATUSES = [
  { value: 'new', label: 'New', attention: true },
  { value: 'interview-invited', label: 'Interview invited' },
  { value: 'interview-complete', label: 'Interview complete' },
  { value: 'final-review', label: 'Final review' },
  { value: 'offer', label: 'Offer' },
]

async function fetchCount(status) {
  try {
    const res = await fetch(
      `/payload-api/job-applications?limit=0&where[status][equals]=${status}`,
      { credentials: 'include' }
    )
    if (!res.ok) return null
    const data = await res.json()
    return data.totalDocs ?? 0
  } catch {
    return null
  }
}

export function CareersToolbar() {
  const [counts, setCounts] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadCounts = async () => {
      const results = await Promise.all(
        STATUSES.map((s) =>
          fetchCount(s.value).then((count) => ({
            status: s.value,
            count,
          }))
        )
      )
      const countMap = {}
      results.forEach((r) => {
        countMap[r.status] = r.count
      })
      setCounts(countMap)
      setLoading(false)
    }
    loadCounts()
  }, [])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 12,
        flexWrap: 'wrap',
      }}
    >
      {STATUSES.map((statusDef) => {
        const count = counts[statusDef.value]
        const isAttention = statusDef.attention && count && count > 0
        const href = `/admin/collections/job-applications?where[status][equals]=${statusDef.value}`

        return (
          <a
            key={statusDef.value}
            href={href}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 12px',
              borderRadius: 4,
              textDecoration: 'none',
              border: `1px solid ${
                isAttention
                  ? '#C9A84C'
                  : 'var(--theme-elevation-150)'
              }`,
              background: isAttention
                ? 'rgba(201, 168, 76, 0.05)'
                : 'var(--theme-elevation-50)',
              color: isAttention
                ? '#C9A84C'
                : 'var(--theme-text)',
              fontSize: 13,
              fontWeight: 500,
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              if (!isAttention) return
              e.currentTarget.style.background = 'rgba(201, 168, 76, 0.1)'
              e.currentTarget.style.borderColor = '#D4B966'
            }}
            onMouseLeave={(e) => {
              if (!isAttention) return
              e.currentTarget.style.background = 'rgba(201, 168, 76, 0.05)'
              e.currentTarget.style.borderColor = '#C9A84C'
            }}
          >
            <span>{statusDef.label}</span>
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                height: 20,
                borderRadius: 10,
                background: isAttention
                  ? '#C9A84C'
                  : 'var(--theme-elevation-200)',
                color: isAttention
                  ? 'white'
                  : 'var(--theme-elevation-600)',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              {loading ? '…' : count ?? '—'}
            </span>
          </a>
        )
      })}
    </div>
  )
}
